<template>
    <div>
        <h2 v-if="tree !== null">Award - {{ awardIndex + 1}}</h2>
        <div @click="removeTheAward()" v-if="tree !== null && awardIndex > 0" style="margin-top: -48px; margin-left: 120px; margin-bottom: 30px">
            <icon-tooltip
                    tooltip-name="period-delete"
                    tooltip-text="To delete this award just select this icon."
                    side="right"
                    text-width="200"
                    icon-type="delete"
                    icon-colour="m-icon--dark">
            </icon-tooltip>
        </div>
        <injury-select
            v-if="tree !== null"
            :tree="tree"
            :selected="selected"
            :awardIndex="awardIndex"
            :level="0"
            v-on:injury-selected="selectedInjury"
            v-on:award-selected="selectedAward">
        </injury-select>
        <div :class="{ 'a-loader--generalDamages' : tree === null }"></div>
        <hr v-if="tree !== null && award.generalDamages" />
    </div>
</template>
<script>

    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import FormValidator from 'components/form/validator/mixin';
    import StepButton from 'components/StepButton.vue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import { setStepValid }  from 'services/routingMethods';
    import { mapGetters, mapActions } from 'vuex';
    import InjurySelect from 'pages/personal-injury-claims/components/InjurySelect.vue';
    import IconTooltip from 'components/IconTooltip';

    export default {
        name: 'psla-award',
        props: ['award', 'awardIndex'],
        computed: {
            ...mapGetters('personal/generalDamages', {
                getTree: 'getTree',
            }),
            selected: {
                get() {
                    return this.award.path;
                },
            },
            tree: {
                get() {
                    return this.getTree;
                },
            },
        },
        mounted() {
            this.fetchInjuries();
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        mixins: [
            FormValidator
        ],
        components: {StepButton, Control, ControlError, DateInput, InjurySelect, IconTooltip},
        methods: {
            ...mapActions('personal/generalDamages', {
                updateValue: 'updateValue',
                removeAward: 'removeAward',
                fetchInjuries: 'fetchInjuries',
            }),
            selectedInjury(val) {
                if (typeof this.path === 'undefined') {
                    this.path = this.getPath || [];
                }

                if (val.level === 0) {
                    this.path = [];
                    this.path[val.level] = val.value;
                    this.updateValid();
                    this.updateValue({key: 'path', value: this.path, index: this.awardIndex});
                    return
                }

                this.path = this.path.slice(0, val.level);
                this.path[val.level] = val.value;
                this.updateValid();
                this.updateValue({key: 'path', value: this.path, index: this.awardIndex});
            },
            updateValid() {
                setStepValid(this.isValid());
            },
            isValid() {
                return this.$valid() && this.award.getGeneralDamages > 0;
            },
            selectedAward() {
                this.$emit("award-selected")
            },
            removeTheAward() {
                this.removeAward(this.awardIndex);
            }
        }
    }
</script>





// WEBPACK FOOTER //
// Award.vue?2b431737